function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5806 0.483214L13.6775 0.365804C14.0932 -0.079147 14.7532 -0.123572 15.2177 0.262134L15.3274 0.365804L21.1583 6.6085C21.5739 7.05349 21.6154 7.76 21.2551 8.25723L21.1583 8.37339L15.3286 14.6236C14.8947 15.0993 14.1887 15.1277 13.7226 14.6884C13.2564 14.249 13.1935 13.4958 13.5794 12.9748L13.6763 12.8574L17.5141 8.7431H1.66687C1.0753 8.74302 0.577382 8.26908 0.508168 7.6402L0.5 7.49407C0.5 6.86083 0.942835 6.32786 1.53035 6.25377L1.66687 6.24503H17.5176L13.6775 2.13194C13.2618 1.68695 13.2203 0.980438 13.5806 0.483214L13.6775 0.365804L13.5806 0.483214Z",
  fill: "white"
});
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.dec0bca5b55f7dad3143678e643afb93.svg";
export { ForwardRef as ReactComponent };